export default "__VITE_ASSET__DajzgevQ__"